export default "__VITE_ASSET__BA2qR6AX__"